import ApiClient from './ApiClient';

export default class AlertsApiClient extends ApiClient {
    
    query(offset, length) {

        return super.post('Alerts', 'Query', { Offset: offset, Length: length });

    }
    
    create(alert) {

        return super.post('Alerts', 'Create', alert);

    }
    
    run(key) {

        return super.post('Alerts', 'Run', { Key: key });

    }
    
    delete(key) {

        return super.post('Alerts', 'Delete', { Key: key });

    }

}


// WEBPACK FOOTER //
// ./src/stores/AlertsApiClient.js